import { apiSlice } from "@/redux/apiSlice";

export const summaryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getShipWalkTestData: builder.query({
        query: ({ projectId }) => `/projects/summary/getShipWalkTestData/${projectId}`,
      }),
      getPrimaryPackageRQLData: builder.query({
        query: ({ projectId }) => `/projects/summary/getPrimaryPackageRQLData/${projectId}`,
      }),
      getSynopsisData: builder.query({
        query: (projectId ) => `/projects/summary/getSynopsisData/${projectId}`,
      }),
      updateSynopsisData: builder.mutation({
        query: ({ projectId, ...data }) => ({
          url: `/projects/summary/updateSynopsisData/${projectId}`,
          method: 'POST',
          body: data,
        }),
      }),
      // Backend generates the report PDF and pushes it to 3DX.
      pushPdfTo3Dx: builder.mutation<{ message?: string }, { projectId: number | string; sections: string[]; imageIds: number[] }>({
        query: ({ projectId, sections, imageIds }) => ({
          url: `/threedx/projects/${projectId}/push-report`,
          method: 'POST',
          body: { sections, imageIds },
        }),
      }),
  }),
});



export const {
    useGetShipWalkTestDataQuery,
    useGetPrimaryPackageRQLDataQuery,
    useGetSynopsisDataQuery,
    useUpdateSynopsisDataMutation,
    usePushPdfTo3DxMutation
} = summaryApiSlice;
